// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
      resetPassword: `${ROOTS.AUTH}/jwt/reset-password`
    },
  },
  // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}/assignment/mcq`,

    assignment: {
      root: `${ROOTS.DASHBOARD}/assignment/mcq`,
      mcq: `${ROOTS.DASHBOARD}/assignment/mcq`
    },
    syllabus: {
      root: `${ROOTS.DASHBOARD}/syllabus/physics`,
      physics: `${ROOTS.DASHBOARD}/syllabus/physics`
    },

    site: {
      root: `${ROOTS.DASHBOARD}/site/announcement`,
      announcement: `${ROOTS.DASHBOARD}/site/announcement`
    },

    user: {
      root: `${ROOTS.DASHBOARD}/user/staff`,
      staff: `${ROOTS.DASHBOARD}/user/staff`
    },
    profile: {
      root: `${ROOTS.DASHBOARD}/profile/account`,
      account: `${ROOTS.DASHBOARD}/profile/account`,
      security: `${ROOTS.DASHBOARD}/profile/security`
    }
  }
};